module.exports = __webpack_public_path__ + "static/img/hover-iocn68.4c70553.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn68.png
// module id = 4Pz9
// module chunks = 1